export default __webpack_public_path__ + "static/media/dashboard-light.5bc41550.webp";